import {Alert} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {
  getLivebarnMissingSegmentWarning,
  livebarnRegex,
} from '../../../services/videoService';
import VideoTypeHeader from './VideoTypeHeader';
import SelectVideoFiles from './SelectVideoFiles';
import {VideoTypes} from '../../../enums';
import {useTranslation} from 'react-i18next';
import AddVideoWrapper from './AddVideoWrapper';
import {CreateSegmentResponsePayload} from '../../../store/sessionVideoSlice';

interface Props {
  setShowModal: (showModal: boolean) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  createSegment: (params: {
    fileName?: string;
    parts?: number;
    veoUrl?: string;
  }) => Promise<{payload: CreateSegmentResponsePayload}>;
  createSegmentComplete: (params: {
    uploadId: string;
    key: string;
    parts: object[];
  }) => void;
  processVideo: () => void;
  refresh: () => void;
}

const AddLiveBarnVideo: React.FC<Props> = ({
  setShowModal,
  loading,
  setLoading,
  createSegment,
  createSegmentComplete,
  processVideo,
  refresh,
}) => {
  const {t} = useTranslation();
  const [livebarnMissingSegmentWarning, setLivebarnMissingSegmentWarning] =
    useState<string | null>(null);
  const [files, setFiles] = useState<FileList | null>(null);
  const [isValidFilenames, setIsValidFilenames] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    setLivebarnMissingSegmentWarning(
      files
        ? getLivebarnMissingSegmentWarning(
            [...(files ?? [])].map(file => file.name),
          )
        : null,
    );

    if (files) {
      const filenames = [...files].map(file => file.name);
      const validFilenames = filenames.filter(filename =>
        livebarnRegex.exec(filename),
      );
      setIsValidFilenames(validFilenames.length === filenames.length);
    } else {
      setIsValidFilenames(null);
    }
  }, [files]);

  return (
    <AddVideoWrapper type={VideoTypes.livebarn}>
      <VideoTypeHeader type={VideoTypes.livebarn} />
      {livebarnMissingSegmentWarning && (
        <Alert severity="warning" variant="outlined" sx={{mb: 1}}>
          {livebarnMissingSegmentWarning}
        </Alert>
      )}
      {files && !isValidFilenames && (
        <Alert severity="error" variant="outlined" sx={{mb: 1}}>
          {t('video.videoTypes.livebarn.invalidFilenameError')}
        </Alert>
      )}
      <SelectVideoFiles
        setShowModal={setShowModal}
        loading={loading}
        setLoading={setLoading}
        files={files}
        setFiles={setFiles}
        disableUpload={!!files && !isValidFilenames}
        createSegment={createSegment}
        createSegmentComplete={createSegmentComplete}
        processVideo={processVideo}
        refresh={refresh}
      />
    </AddVideoWrapper>
  );
};

export default AddLiveBarnVideo;
